import { useSelector } from 'react-redux';
import { getHasFtp } from 'domains/Auth/authSlice/authSelectors';

function useHasFtp(): boolean {
  return useSelector(getHasFtp);
}

export default useHasFtp;
